import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../Utils/Functions/Dexie-Setup";
import { useState, useEffect, useRef, useMemo } from "react";

const TextMultiLineInput = ({ tableName, primaryKey, fieldName, label, ...rest }) => {
  const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
  const [value, setValue] = useState("");
  const updatedAt = useRef(0);
  const timeout = useRef("");
  const recordType = useMemo(() => String, []);
  const inputType = useMemo(() => String, []);

  const onChange = (e) => {
    updatedAt.current = Date.now();
    setValue(e.target.value);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      db[tableName].update(primaryKey, { [fieldName]: recordType(e.target.value), locallyUpdatedAt: Date.now() })
    }, 150);
  }

  useEffect(() => {
    if (record !== undefined) {

      if (!updatedAt.current || updatedAt.current < record.locallyUpdatedAt) {
        setValue(record[fieldName] ? inputType(record[fieldName]) : "");
      }
    }
  }, [record, fieldName, inputType])

  useEffect(() => {
    setValue("");
    updatedAt.current = 0;
    clearTimeout(timeout.current)
    timeout.current = "";
  }, [tableName, primaryKey, fieldName])

  return (
    <>
      <label htmlFor={`${primaryKey}-${fieldName}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <textarea value={value} onChange={onChange} id={`${primaryKey}-${fieldName}`} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" {...rest} />
    </>
  )
}

export default TextMultiLineInput
